
export class GrossWeightRequest {
    saleOrderItemId: number;
    grossWeight: number;
    constructor(saleOrderItemId: number,grossWeight: number){
        this.saleOrderItemId=saleOrderItemId
        this.grossWeight= grossWeight
    }
}